"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowerPlantConstructionTypes = exports.PowerPlantPropertyTypes = exports.SignedImageValidationSchema = exports.ImageValidationSchema = exports.TPropertyTypeGermanConverter = exports.RepaymentTypes = exports.TPropertyType = exports.THeatingTypeGermanConverter = exports.THeatingType = exports.TBuildingConditionGermanConverter = exports.TConstructionStatus = exports.TBuildingCondition = exports.TContractTypeGermanConverter = exports.TContractType = exports.TTerminationRight = exports.TPayoutInterval = exports.TSecurityType = exports.TAssetStage = void 0;
const zod_1 = require("zod");
var TAssetStage;
(function (TAssetStage) {
    /** Capturing of asset information is still in progress, not all required information has been filled out by the issuer yet. The asset is not yet available in the app for investors. */
    TAssetStage["preparing"] = "preparing";
    /** The issuer requested the asset to be reviewed by the marketplace operator. The asset is not yet available in the app for investors. */
    TAssetStage["review"] = "review";
    /** Asset was approved by the marketplace operator. The asset is not yet available in the app for investors. */
    TAssetStage["approved"] = "approved";
    /** Asset was declined by the marketplace operator. The asset is not yet available in the app for investors, the asset issuer needs to make changes and resubmit the asset. */
    TAssetStage["declined"] = "declined";
    /** The asset shares are on the primary market, users can start investing in it. */
    TAssetStage["primary"] = "primary";
    /** Asset is tradeable on the secondary market, investors can buy and sell shares between each other. */
    TAssetStage["emitting"] = "emitting";
    /** Emission failed */
    TAssetStage["emissionFailed"] = "emissionFailed";
    /** Asset is tradeable on the secondary market. */
    TAssetStage["secondary"] = "secondary";
})(TAssetStage = exports.TAssetStage || (exports.TAssetStage = {}));
var TSecurityType;
(function (TSecurityType) {
    /** Users can invest and become part-owners of the asset. They get a share of the rental income and the increase of the asset's value over time. */
    TSecurityType["participationRightEquity"] = "participationRightEquity";
    /** Similar to participationRightEquity, but it's used for assets that are not yet built. Once the property is completed and starts generating income, the investors will benefit from it the same way as in the equity case. */
    TSecurityType["participationRightEquityBuilderOwner"] = "participationRightEquityBuilderOwner";
    /** Investors do not become part-owners of the asset and do not receive part of the income like with participationRightEquity. Instead, they get a fixed interest rate on their investment. */
    TSecurityType["participationRightDebtCapital"] = "participationRightDebtCapital";
    /** Similar to participationRightDebtCapital, but with the potential for additional returns if the property is sold. */
    TSecurityType["participationRightDebtCapitalPartialSale"] = "participationRightDebtCapitalPartialSale";
    TSecurityType["participationAtypicalSilent"] = "participationAtypicalSilent";
    TSecurityType["participationKG"] = "participationKG";
    TSecurityType["purchaseWithManagementOutsourcing"] = "purchaseWithManagementOutsourcing";
})(TSecurityType = exports.TSecurityType || (exports.TSecurityType = {}));
var TPayoutInterval;
(function (TPayoutInterval) {
    TPayoutInterval["monthly"] = "monthly";
    TPayoutInterval["quarterly"] = "quarterly";
    TPayoutInterval["yearly"] = "yearly";
})(TPayoutInterval = exports.TPayoutInterval || (exports.TPayoutInterval = {}));
var TTerminationRight;
(function (TTerminationRight) {
    TTerminationRight["no"] = "no";
    TTerminationRight["issuer"] = "issuer";
    TTerminationRight["investor"] = "investor";
    TTerminationRight["issuerAndInvestor"] = "issuerAndInvestor";
})(TTerminationRight = exports.TTerminationRight || (exports.TTerminationRight = {}));
var TContractType;
(function (TContractType) {
    TContractType["open"] = "open";
    TContractType["closed"] = "closed";
    TContractType["notRented"] = "notRented";
})(TContractType = exports.TContractType || (exports.TContractType = {}));
var TContractTypeGermanConverter;
(function (TContractTypeGermanConverter) {
    TContractTypeGermanConverter["open"] = "unbefristet";
    TContractTypeGermanConverter["closed"] = "befristet";
    TContractTypeGermanConverter["notRented"] = "nicht vermietet";
})(TContractTypeGermanConverter = exports.TContractTypeGermanConverter || (exports.TContractTypeGermanConverter = {}));
var TBuildingCondition;
(function (TBuildingCondition) {
    TBuildingCondition["old"] = "old";
    TBuildingCondition["new"] = "new";
    TBuildingCondition["massive"] = "massive";
    TBuildingCondition["renovation"] = "renovation";
    TBuildingCondition["newDevelopment"] = "newDevelopment";
})(TBuildingCondition = exports.TBuildingCondition || (exports.TBuildingCondition = {}));
var TConstructionStatus;
(function (TConstructionStatus) {
    TConstructionStatus["stock"] = "stock";
    TConstructionStatus["project"] = "project";
    TConstructionStatus["planning"] = "planning";
    TConstructionStatus["installed"] = "installed";
    TConstructionStatus["connectedToNetwork"] = "connectedToNetwork";
})(TConstructionStatus = exports.TConstructionStatus || (exports.TConstructionStatus = {}));
// We need that as long as the new asset is not implemented
var TBuildingConditionGermanConverter;
(function (TBuildingConditionGermanConverter) {
    TBuildingConditionGermanConverter["old"] = "Altbau";
    TBuildingConditionGermanConverter["new"] = "Neubau";
    TBuildingConditionGermanConverter["massive"] = "Massiv";
})(TBuildingConditionGermanConverter = exports.TBuildingConditionGermanConverter || (exports.TBuildingConditionGermanConverter = {}));
var THeatingType;
(function (THeatingType) {
    THeatingType["oil"] = "oil";
    THeatingType["naturalGas"] = "naturalGas";
    THeatingType["district"] = "district";
    THeatingType["central"] = "central";
    THeatingType["woodPellet"] = "woodPellet";
    THeatingType["electric"] = "electric";
    THeatingType["floorCentral"] = "floorCentral";
    THeatingType["solar"] = "solar";
    THeatingType["heatpump"] = "heatpump";
})(THeatingType = exports.THeatingType || (exports.THeatingType = {}));
var THeatingTypeGermanConverter;
(function (THeatingTypeGermanConverter) {
    THeatingTypeGermanConverter["central"] = "Zentralheizung";
    THeatingTypeGermanConverter["district"] = "Fernw\u00E4rme";
    THeatingTypeGermanConverter["floorCentral"] = "Etagenheizung";
})(THeatingTypeGermanConverter = exports.THeatingTypeGermanConverter || (exports.THeatingTypeGermanConverter = {}));
var TPropertyType;
(function (TPropertyType) {
    TPropertyType["firstFloorFlat"] = "firstFloorFlat";
    TPropertyType["studioFlat"] = "studioFlat";
    TPropertyType["cooperativeFlat"] = "cooperativeFlat";
    TPropertyType["loft"] = "loft";
    TPropertyType["duplexHouse"] = "duplexHouse";
    TPropertyType["pentHouse"] = "pentHouse";
    TPropertyType["rawAtticFloor"] = "rawAtticFloor";
    TPropertyType["flat"] = "flat";
    TPropertyType["atticFlat"] = "atticFlat";
    TPropertyType["room"] = "room";
    TPropertyType["commercial"] = "commercial";
    TPropertyType["familyHome"] = "familyHome";
    TPropertyType["partialFamilyHome"] = "partialFamilyHome";
    // TODO: only show for builder owner model
    TPropertyType["apartmentBuilding"] = "apartmentBuilding";
    TPropertyType["loftConversion"] = "loftConversion";
    TPropertyType["demolitionNewConstruction"] = "demolitionNewConstruction";
})(TPropertyType = exports.TPropertyType || (exports.TPropertyType = {}));
exports.RepaymentTypes = ['bulletLoan', 'installmentLoan'];
// We need that as long as the new asset is not implemented
var TPropertyTypeGermanConverter;
(function (TPropertyTypeGermanConverter) {
    TPropertyTypeGermanConverter["flat"] = "Wohnung";
    TPropertyTypeGermanConverter["commercial"] = "Gewerbe";
    TPropertyTypeGermanConverter["familyHome"] = "Einfamilienhaus";
    TPropertyTypeGermanConverter["partialFamilyHome"] = "Haus (Miteigentum)";
})(TPropertyTypeGermanConverter = exports.TPropertyTypeGermanConverter || (exports.TPropertyTypeGermanConverter = {}));
exports.ImageValidationSchema = zod_1.z.object({
    name: zod_1.z.string(),
    src: zod_1.z.string().url(),
});
exports.SignedImageValidationSchema = zod_1.z.object({
    name: zod_1.z.string(),
    src: zod_1.z.string().url(),
    signed: zod_1.z.boolean().default(false),
});
exports.PowerPlantPropertyTypes = ['photovoltaic', 'wind', 'bundle', 'storage'];
exports.PowerPlantConstructionTypes = ['roof', 'landsite', 'integrated'];
//# sourceMappingURL=enums.js.map